import React, {
  useEffect,
  useState,
} from 'react';

import axios from 'axios';

import './OpportunityReviewPage.css';

import {
  Link,
} from 'react-router-dom';

/* global process */

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL;

const REVIEW_URL =
  `${API_BASE_URL}/api/v1/opportunity_reviews`;

const formatDate = (value) => {
  if (!value) return 'No publication date';

  return new Intl.DateTimeFormat(
    'en',
    {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    }
  ).format(new Date(value));
};

const OpportunityReviewPage = () => {
  const [items, setItems] = useState([]);
  const [status, setStatus] =
    useState('loading');
  const [error, setError] =
    useState(null);
  const [busyId, setBusyId] =
    useState(null);

  const loadOpportunities = async () => {
    try {
      setStatus('loading');
      setError(null);

      const response = await axios.get(
        REVIEW_URL
      );

      setItems(response.data);
      setStatus('succeeded');
    } catch (requestError) {
      setStatus('failed');
      setError(
        requestError.message ||
        'Unable to load opportunities.'
      );
    }
  };

  useEffect(() => {
    loadOpportunities();
  }, []);

  const updateOpportunity = async (
    id,
    action
  ) => {
    try {
      setBusyId(id);

      await axios.patch(
        `${REVIEW_URL}/${id}/${action}`
      );

      setItems((currentItems) =>
        currentItems.filter(
          (item) => item.id !== id
        )
      );
    } catch (requestError) {
      setError(
        requestError.message ||
        'Unable to update opportunity.'
      );
    } finally {
      setBusyId(null);
    }
  };

  if (status === 'loading') {
    return (
      <main className="opportunity-review-page admin-page">
        <p className="review-message">
          Loading discovered opportunities...
        </p>
      </main>
    );
  }

  if (status === 'failed') {
    return (
      <main className="opportunity-review-page admin-page">
        <p className="review-message review-error">
          {error}
        </p>
      </main>
    );
  }

  return (
    <main className="opportunity-review-page admin-page">
      <section className="review-header">
        <p className="review-eyebrow">
          ACE opportunity monitoring
        </p>

        <h1>
          Opportunities
        </h1>

        <p>
          Review, edit and prepare automatically
          discovered opportunities before publication.
        </p>
      </section>

      <section className="review-summary">
        <strong>{items.length}</strong>
        <span>
          opportunities awaiting review
        </span>
      </section>

      {error && (
        <p className="review-message review-error">
          {error}
        </p>
      )}

      {items.length === 0 ? (
        <section className="review-empty">
          <h2>Nothing waiting for review</h2>

          <p>
            Newly discovered opportunities will
            appear here.
          </p>
        </section>
      ) : (
        <section className="review-grid">
          {items.map((opportunity) => {
            const isBusy =
              busyId === opportunity.id;

            return (
              <article
                className="review-card"
                key={opportunity.id}
              >
                <div className="review-card-top">
                  <span className="review-source">
                    {opportunity.source_name}
                  </span>

                  <span className="review-status">
                    {opportunity.review_status}
                  </span>
                </div>

                <p className="review-date">
                  Published{' '}
                  {formatDate(
                    opportunity.source_published_at
                  )}
                </p>

                <h2>
                  {opportunity.title_en ||
                    opportunity.title_fr}
                </h2>

                {opportunity.summary_en && (
                  <p className="review-summary-text">
                    {opportunity.summary_en
                      .replace(/<[^>]*>/g, '')
                      .slice(0, 280)}

                    {opportunity.summary_en.length >
                    280
                      ? '...'
                      : ''}
                  </p>
                )}

                <div className="review-actions">
                  <a
                    href={opportunity.source_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="review-link"
                  >
                    View original
                  </a>

                  <Link
                      to={`/admin/opportunities/${opportunity.id}/edit`}
                      className="review-button approve"
                    >
                      Review & Edit
                  </Link>

                  <button
                    type="button"
                    className="review-button reject"
                    disabled={isBusy}
                    onClick={() =>
                      updateOpportunity(
                        opportunity.id,
                        'reject'
                      )
                    }
                  >
                    Reject
                  </button>
                </div>
              </article>
            );
          })}
        </section>
      )}
    </main>
  );
};

export default OpportunityReviewPage;
